<template>
  <div id="app">
    <keep-alive exclude="CarDetail,CarForm,CarList,HouseList,HouseDetail,HouseForm,RunnerDetail,RunnerForm,RunnerList,YmwhxjList,YmwhxjForm,YmwhxjDetail">
      <router-view/>
    </keep-alive>
    
  </div>
</template>
<script>

export default {
  name: 'AppPage',
  props: {
  },
  data () {
    return {
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  methods: {

  }
}

</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 640px;
  width: 100%;
  height: 100vh;
  margin: auto;
}
.live {
  max-width: 640px;
  width: 100vw;
  /* height: 81.875vw; */
  position: relative;
  top: 0;
  left: 0;
  z-index: 100;
  overflow: hidden;
}
.header-bg {
  left: 0;
  width: 100%;
  position: absolute;
}
.player {
  width: 94%;
  left: 3%;
  max-height: 52.875vw;
  margin-top: 29%;
  z-index: 101;
}
.main {
  /* margin-top: 56.3vw; */
  max-width: 640px;
  position: absolute;
  width: 100%;
  /* top: 81.875vw; */
  /* padding-top: 46px; */
  /* padding-bottom: 1rem; */
  overflow-y: scroll;
}
.main-a {
  width: 100%;
  /* height: 100%; */
  position: relative;
  overflow-y: scroll;
}
.home-p, .list, .me-p {
  width: 100%;
  /* margin-top: 46px; */
  height: 100%;
  position: relative;
  /* overflow: scroll; */
}
.merchant-d img {
  max-width: 100%;
}
.merchant-d, .detail {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: scroll;
  /* padding-bottom: 3.5rem; */
}
.van-nav-bar {
  width: 100%;
  position: relative;
  /* top: 81.875vw; */
  left: 0;
  z-index: 100;
}
.tab-bar {
  width: 50vw;
}
.t-list {
  width: 90%;
  height: 100%;
  padding: 0 5%;
  /* padding-bottom: 1.5rem; */
  overflow-y: scroll;
}
.t-item {
  width: 100%;
  height: 24vw;
  display: flex;
  position: relative;
  margin: 0.5rem 0;
  color: #ffffff;
}
.type_1 .t-bc1 {
  /* background-color: rgba(239, 16, 51, 0.6); */
  background-color: #16af93ba;
}
.type_1 .t-bc2 {
  /* background-color: rgba(239, 16, 51); */
  background-color: #16af93;
}
.type_2 .t-bc1 {
  background-color: rgba(16, 136, 239, 0.7);
}
.type_2 .t-bc2 {
  background-color: rgba(16, 136, 239);
}
.type_3 .t-bc1 {
  background-color: rgba(239, 16, 51, 0.6);
}
.type_3 .t-bc2 {
  background-color: rgba(239, 16, 51);
}
.t-header {
  flex: 1.2;
  display: flex;
  font-size: 1.1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.3rem;
}
.t-item .t-header {
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}
.type_1 .t-header {
  background-image: url(./assets/t_quan.png);
}
.type_2 .t-header {
  background-image: url(./assets/t_li.png);
}
.type_3 .t-header {
  background-image: url(./assets/t_jiang.png);
}
.t-get {
  width: 16.8vw;
  font-size: 1rem;
  line-height: 24vw;
  /* background-color: rgb(239, 16, 51); */
  background-image: url(./assets/money.png);
  background-size: 86%;
  background-repeat: no-repeat;
  background-position: 100% 0;
  border-radius: 0.3rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.t-get p {
  width: 2.4em;
  margin: auto;
  line-height: 1.5rem;
  letter-spacing: 2px;
}
.t-desc {
  flex: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.3rem;
}
.t-border {
  position: absolute;
  width: 1.6vw;
  right: 16vw;
  top: 0;
  height: 100%;
  background: url(./assets/point.png) no-repeat 100% 0;
  background-size: 100% 100%;
}
.t-mask {
  width: 100%;
  height: 24vw;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.38);
}
.merchant-d section p {
  font-size: 0.85rem;
  margin: 0.6rem 0;
}
.van-address-edit__buttons {
  padding: 10px;
}
.dplayer-full-in-icon {
  display: none !important;
}
</style>
